import type { CSSProperties } from 'react'

export type SelectTokenStyle = CSSProperties & { [key in `--select-${string}`]?: string }

export const selectInvertedStyle: SelectTokenStyle = {
  '--select-bg': '#1F1F1F',
  '--select-bg-disabled': '#1F1F1F',
  '--select-border': '#404040',
  '--select-border-focus': '#A885FF',
  '--select-border-disabled': '#404040',
  '--select-text': '#FEFEFE',
  '--select-text-disabled': '#A8A8A8',
  '--select-icon': '#FEFEFE',
  '--select-ring': '#A885FF',
  '--select-ring-offset': '#1F1F1F',
}
